import { HistoryMovement, Range } from 'types';

type GetHistoryMovementsProps = {
  validatedRanges: Range[];
  holdingClassName: string;
  partnerName: string;
  sharePrice: number;
};

export const getHistoryMovements = ({
  validatedRanges,
  holdingClassName,
  partnerName,
  sharePrice,
}: GetHistoryMovementsProps): HistoryMovement[] => {
  const historyMovements: HistoryMovement[] = [];

  validatedRanges.forEach((range: Range) => {
    historyMovements.push({
      from: range.from,
      to: range.to,
      holdingClassName: holdingClassName || '',
      partnerNameSeller: partnerName || '',
      sharePrice,
    });
  });

  return historyMovements;
};
